<template>
  <el-row class="form-item non-menu-less-budget">
    <el-col :span="2"><span class="required-text">*</span>选择预算</el-col>
    <el-col :span="17">
      <el-radio-group v-model="activeBtn" class="radio-btn" @change="onActiveBtnChanged">
        <!-- <el-radio-button label="pocm">
          <i class="iconfont iconzu91" v-if="activeBtn === 'pocm'"/>
          <span v-if="itemType !== '03'">区域POCM预算</span>
          <span v-else>区域Non-Menu预算</span>
        </el-radio-button> -->
        <!-- <el-select v-model="payload.quotaId" placeholder="请选择" v-if="activeBtn === 'pocm'" size="small" @change="setValue">
          <el-option
            v-for="item in pocmList"
            :key="item.quotaDTO.quotaId"
            :label="item.quotaDTO.quotaName"
            :value="item.quotaDTO.quotaId" />
        </el-select> -->

        <!-- TR预算 -->
        <el-radio-button label="tr">
          <i class="iconfont iconzu91" v-if="activeBtn === 'tr'"/>TR预算
        </el-radio-button>
        <el-select v-model="payload.quotaId" filterable placeholder="请选择" style="width:350px;" v-if="activeBtn === 'tr'" @change="changeTr" clearable>
            <el-option v-for="(item,index) in trList" :key="index" :label="`${item.trKhCode}-${item.orgName}`" :value="item.quotaId" />
          </el-select>
      </el-radio-group>
      <!-- <el-input placeholder="请填写TR Code" v-if="activeBtn === 'tr'" class="input-round" v-model="payload.trKhCode" @input="inputTr">
        <i slot="suffix" v-if="trVer.show && trVer.success" class="el-input__icon el-icon-success" style="color: #21BA45"></i>
        <i slot="suffix" v-if="trVer.show && !trVer.success" class="el-input__icon el-icon-error" style="color: #C8102D"></i>
      </el-input>
      <el-button class="btn-blue" v-if="activeBtn === 'tr'" size="small" @click="getTrInfo">验证</el-button> -->
    </el-col>
    <el-col :span="5">
      <span>当前可使用预算￥</span>
      <span>{{ payload.budget }}</span>
    </el-col>

    <el-dialog :visible.sync="quotaDialogVisible" width="50%" title="选取配额">
      <el-table :data="quotaList">
        <el-table-column prop="quotaName" label="配额名称"></el-table-column>
        <el-table-column prop="availableQuota" label="可用配额"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button class="btn-blue" size="small" @click="handleCheckTrCode(scope.row)">选取</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button class="btn-red" @click="quotaDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
export default {
  name: 'item-order-budget-picker',
  props: {
    itemType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      activeBtn: 'tr',
      payload: {
        quotaId: '',
        trKhCode: '',
        budget: 0,
        orgCode: ''
      },
      pocmList: [],
      trVer: {
        show: false,
        success: false
      },
      trList: [],
      budget: 0,
      quotaDialogVisible: false,
      quotaList: []
    }
  },
  watch: {
    'payload.quotaId' (val) {
      // if (val) {
      // for (let i = 0; i < this.pocmList.length; i++) {
      //   if (this.pocmList[i].quotaId === val) {
      //     this.payload.budget = this.pocmList[i].availableQuota
      //     return
      //   }
      // }
      // }

      // 设置可用预算
      let arr = []
      arr = this.trList.filter(item => {
        return item.quotaId === val
      })
      this.payload.budget = arr.length ? arr[0].availableQuota : 0
    },
    'payload.budget' (val) {
      this.$store.commit('setBudget', val)
    }
  },
  created () {
    this.getPocmTrList()
    this.queryPocmList()
  },
  methods: {
    // 获取pocm预算表
    queryPocmList () {
      let params = {
        quotaType: this.itemType
      }
      if (params.quotaType !== '03') {
        params.quotaType = '01'
      }
      this.$store.dispatch('queryPocmList', params).then(res => {
        if (res.data.resultCode === '0') {
          this.pocmList = res.data.resultData.quotaDetailList || []
        }
      })
    },
    onActiveBtnChanged (val) {
      this.payload.trKhCode = ''
      this.payload.quotaId = ''
      this.payload.budget = 0
      this.setValue()
    },
    // 验证tr信息
    getTrInfo () {
      if (!this.payload.trKhCode) {
        this.budget = 0
        this.setValue()
        this.$message.error('请输入tr预算编码')
        return
      }
      this.$store.dispatch('getTrInfo', this.payload.trKhCode).then(res => {
        if (res.data.resultCode === '0') {
          this.trVer.show = true
          if (!res.data.resultData.quotaList) {
            this.$message.error('无此预算')
            this.payload.trKhCode = ''
            this.payload.budget = 0
            this.trVer.success = false
          } else if (res.data.resultData.quotaList.length) {
            this.quotaList = []
            this.quotaList = res.data.resultData.quotaList
            if (this.quotaList.length > 1) {
              this.quotaDialogVisible = true
            } else {
              this.trVer.success = true
              this.payload.trKhCode = this.quotaList[0].trKhCode
              this.payload.orgCode = this.quotaList[0].orgCode
              this.payload.budget = this.quotaList[0].availableQuota
            }
          }
          this.setValue()
        }
      })
    },
    // 多条tr 选择其一
    handleCheckTrCode (row) {
      this.payload.trKhCode = row.trKhCode
      this.payload.orgCode = row.orgCode
      this.payload.budget = row.availableQuota
      this.trVer.success = true
      this.quotaDialogVisible = false
      this.setValue()
    },

    setValue () {
      this.$emit('setValue', this.payload)
    },
    inputTr () {
      this.trVer.show = false
    },
    // 更改Tr预算
    changeTr (quotaId) {
      let arr = this.trList.filter(item => {
        return item.quotaId === quotaId
      })
      this.payload.trKhCode = arr.length ? arr[0].trKhCode : ''
      this.setValue()
    },
    // 获取TR预算列表
    getPocmTrList () {
      const params = {
        subBrandIds: ''
      }
      this.$store.dispatch('getPocmTrList', params).then(res => {
        if (res.data.resultCode === '0') {
          this.trList = res.data.resultData.quotaList
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.form-item {
  height: 100px;
  line-height: 100px;
  padding-right: 10px;
  .el-col-17 {
    height: 100%;
    display: flex;
    align-items: center;
    .el-input {
      width: 180px;
    }
    .el-select {
      vertical-align: middle;
      margin-right: $content-large;
      margin-left: -15px;
      width: 180px;
    }
  }
  .input-round {
    margin-right: 10px;
  }
  .iconzu91 {
    font-size: 20px;
    padding-right: 5px;
    vertical-align: middle;
  }
  .el-dialog__wrapper {
    line-height: 0;
  }
}
</style>
